// Valores estáticos para configuración de la app
//export const ENDPOINT = "http://localhost:8001";
export const ENDPOINT = "https://email.service-gestrescan.com";
export const DEFAULT_STORE = "1";
export const DEFAULT_ROLE = "3";
export const LIMIT_PAGE_SIZE = "1000";
export const NON_ERASABLE_STATUSTYPE_ID = "10";
export const NON_ERASABLE_REASONTYPE_ID = "26";
export const NON_ERASABLE_STORE_ID = "3";
export const NON_ERASABLE_USERACCOUNT_ID = "10";
export const DELETE_CODE = "000000";
export const DELETE_CODE_STORE = "123456789";
